export type SignOutFollowUp = 'authenticate' | 'closeOrAuthenticate' | 'none';
